import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SideMenuService } from 'src/app/shared/side-menu/side-menu.service';
import { SitesService } from 'src/app/sites/sites.service';
import * as moment from 'moment';
import { DeviceFactory } from '../../../../device-factory/device-factory';

@Component({
	selector: 'app-daily-truck-fleet-activity-metrics',
	templateUrl: './daily-truck-fleet-activity-metrics.component.html',
	styleUrls: ['./daily-truck-fleet-activity-metrics.component.css']
})
export class DailyTruckFleetActivityMetricsComponent implements OnInit, OnChanges {

	@Input() toDate = new Date();
	@Input() fromDate = new Date(this.toDate.getTime() - 30 * 24 * 60 * 60 * 1000); // 30 days ago
	@Input() selectedTruckType = "All";
	@Input() selectedTruckManufacturer = "All";
	@Output() prepareParentFiltersOptions = new EventEmitter<{ truckTypes: any[], truckManufacturers: any[] }>();

	devicesType = [DeviceFactory.types.iotah];
	siteId!: number;
	siteSubscription: any;
	devices: any = {};
	data: any = {};
	noData: boolean = false;
	siteInstallationDate: Date = new Date(0);

	daysFilters = [
		{ value: 'allDays', label: this.translate.instant('g.all_days') },
		{ value: 'workingDays', label: this.translate.instant('g.working_days') },
	];

	selectedDaysFilter = this.daysFilters[0].value;

	constructor(
		private translate: TranslateService,
		private sitesService: SitesService,
		private route: ActivatedRoute,
		private sideMenuService: SideMenuService,
	) { }

	ngOnInit() {
		this.siteId = this.route.parent.snapshot.params.siteId || 0;
		this.siteSubscription = this.sideMenuService.currentSite.subscribe((siteInfo:any) => {
			if (siteInfo && siteInfo.installation_date) {
				this.siteInstallationDate = moment.utc(siteInfo.installation_date).startOf('day').toDate();
				if (this.siteInstallationDate > this.fromDate)
					this.fromDate = this.siteInstallationDate;
			}
		});
		this.getDailyTruckFleetActivityMetrics();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes?.['fromDate'])
			this.changeDate('fromDate', changes['fromDate'].currentValue);

		if (changes?.['toDate'])
			this.changeDate('toDate', changes['toDate'].currentValue);

		if (changes?.['selectedTruckType'])
			this.onSelectionChanged({ filter: 'truckType', value: changes['selectedTruckType'].currentValue });

		if (changes?.['selectedTruckManufacturer'])
			this.onSelectionChanged({ filter: 'truckManufacturer', value: changes['selectedTruckManufacturer'].currentValue });
	}


	getDailyTruckFleetActivityMetrics() {
		let zoneDiff = new Date().getTimezoneOffset() * -1;
		const now = moment().startOf('day');
		const to = moment(this.toDate).startOf('day');

		if (to.isSameOrAfter(now)) {
			this.toDate = moment().subtract(1, 'day').startOf('day').toDate();
		}

		let fromDate: any = new Date(new Date(this.fromDate).getTime() + (zoneDiff * 60 * 1000));
		let toDate: any = new Date(new Date(this.toDate).getTime() + (zoneDiff * 60 * 1000));

		fromDate = moment(fromDate).utc().startOf('day').unix();
		toDate = moment(toDate).utc().endOf('day').unix();

		if (!this.siteId)
			return;

		const criteria: any = {
			truck_type: this.selectedTruckType,
			truck_manufacturer: this.selectedTruckManufacturer
		};

		this.sitesService.getDailyTruckFleetActivityMetrics(this.siteId, fromDate, toDate, this.devicesType, criteria).subscribe((res: any) => {
			this.data = res.data || {};
			this.devices = res.devices || {};
			this.prepareTruckTypesAndManufacturers();
		});
	}

	prepareTruckTypesAndManufacturers() {
		const truckTypes = [{ value: 'All', label: 'All' }];
		const truckManufacturer = [{ value: 'All', label: 'All' }];

		for (const macAddress in this.devices) {
			const device = this.devices[macAddress];
			if (device.truck_type) {
				const isExist = truckTypes.find((type) => type.value == device.truck_type);
				if (!isExist)
					truckTypes.push({
						value: device.truck_type,
						label: device.truck_type,
					});
			}

			if (device.truck_manufacturer) {
				const isExist = truckManufacturer.find((type) => type.value == device.truck_manufacturer);
				if (!isExist)
					truckManufacturer.push({
						value: device.truck_manufacturer,
						label: device.truck_manufacturer,
					});
			}
		}

		this.prepareParentFiltersOptions.emit({ truckTypes: structuredClone(truckTypes), truckManufacturers: structuredClone(truckManufacturer) });
	}

	onSelectionChanged(event) {
		switch (event.filter) {
			case 'truckType':
				this.selectedTruckType = event.value;
				break;
			case 'truckManufacturer':
				this.selectedTruckManufacturer = event.value;
				break;
			case 'daysFilter':
				this.selectedDaysFilter = event.value;
				break;
			default:
				break;
		}
		this.getDailyTruckFleetActivityMetrics();
	}

	changeDate(field, value) {
		this[field] = value;
		this.getDailyTruckFleetActivityMetrics();
	}
}
